export const DUMMY_PERMISSION_MANAGER = {
  hasPermission: (_) => true,
  hasAnyPermission: (_) => true,
  hasAllPermission: (_) => true
};
